<template>
  <div>
    <div :class="openSideMenu ? 'nav-icon' : 'nav-icon'" style="float:left" @click="openMenu">
      <i class="el-icon-s-tools spin icon-size"></i>
    </div>
    <el-drawer
      size="50%"
      :direction="direction"
      :visible.sync="openSideMenu"
      :show-close="true"
      :custom-class="'sideMenu'"
      :modal="true"
      :before-close="closeModal"
    >
      <div class="row" style="height: 100%; display: flex; flex-direction: column; justify-content: center">
        <button aria-label="close drawer" @click="openMenu" type="button" class="el-drawer__close-btn"><i
          class="el-dialog__close el-icon el-icon-close"></i></button>
        <div class="col-md-10 col-md-offset-1">
          <div v-for="(element, index) in routesArray" :key="index" class="col-xs-10 col-xs-offset-1 col-sm-6"
               :class="calculatePositionOnGridSideMenu(index+1)">
            <div :class="element.isDisabled(buttonClicked, sitecode, firstRegistration) ? 'disabled' : ''">
              <router-link
                role="link"
                :to="element.route"
                @click.native="buttonClick"
                :disabled="element.isDisabled(buttonClicked, sitecode, firstRegistration)"
              >
                <div class="grid-content">
                  <p class="text-center">
                    <img :src="'static/img/dashboard/' + element.image + '.png'" alt="img"/>
                  </p>
                  <br/>
                  <br/>
                  <div class="text-center textButton">
                    {{ computeCaption(element.buttonText, $store.state.lang.value.toLowerCase()) }}
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="col-md-12 col-sm-12 col-xs-12 text-center">
            <el-button class="logoutBtn" @click="buttonClickLogOut" style="margin-top: 40px">
              {{ computeCaption(fields_en['logout'], $store.state.lang.value.toLowerCase()) }}
            </el-button>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {Input, Button, RadioGroup, Radio, RadioButton, Drawer} from 'element-ui'
import {TranslationsUtils} from '../../../../../../utils/Translations'
import {gridUtils} from '../../../../../../utils/DashboardGrid'
export default {
  name: 'SideMenu',
  props: {
  },
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
    [Input.name]: Input,
    [Button.name]: Button,
    [Drawer.name]: Drawer
  },
  mixins: [
    TranslationsUtils,
    gridUtils
  ],
  data () {
    return {
      openSideMenu: false,
      direction: 'rtl',
      buttonClicked: false,
      sitecode: this.$store.state.sitecode,
      firstRegistration: this.$store.state.firstRegistration,
      fields_en: {
        edit_personal_data: 'Edit Personal Data',
        dependents: 'Dependents',
        manage_account: 'Manage Your Account',
        logout: 'Log Out'
      }
    }
  },
  methods: {
    closeModal () {
      this.openSideMenu = false
      const panel = document.getElementsByClassName('main-panel')[0]
      panel.style.overflow = 'auto'
      panel.style.position = 'relative'
    },
    openMenu () {
      this.openSideMenu = !this.openSideMenu
      const panel = document.getElementsByClassName('main-panel')[0]
      if (this.openSideMenu) {
        panel.style.overflow = 'hidden'
        panel.style.position = 'fixed'
      } else {
        panel.style.overflow = 'auto'
        panel.style.position = 'relative'
      }
    },
    buttonClick () {
      const panel = document.getElementsByClassName('main-panel')[0]
      panel.style.overflow = 'auto'
      panel.style.position = 'relative'
      this.buttonClicked = true
      this.openSideMenu = false
    },
    buttonClickLogOut () {
      const panel = document.getElementsByClassName('main-panel')[0]
      panel.style.overflow = 'auto'
      panel.style.position = 'relative'
      localStorage.clear()
      window.location.href = window.origin + '/#/?lang=' + this.$route.query.lang
      window.location.reload()
    },
    calculatePositionOnGridSideMenu (index) {
      let i
      this.rowLayout[this.routesArray.length].every((element, idx) => {
        if (index > element) {
          index = index - element
          return true
        } else {
          i = idx
          return false
        }
      })
      return this.cssClassPerRow[this.routesArray.length][i]
    }
  },
  watch: {
  },
  computed: {
  }
}
</script>

<style lang="scss">
@import '../../../../../../assets/sass/paper/variables';
.el-drawer__container {
  background: #00000036;
}
.sideMenu .el-drawer__header{
  display: none;
}
.sideMenu .el-icon-close{
  position: absolute;
  left:20px;
  top:20px;
}

.nav-icon{
  width: 25px;
  height: 17px;
  margin: 25px 0px 20px 20px;
  position: relative;
  cursor: pointer;
  display: inline-block;
}

.icon-size {
  font-size: 23px;
  color: $primary-color;
}

.spin:hover {
    position: relative;
    cursor: pointer;
    display: inline-block;
    background: transparent;
    -webkit-animation-name: spin;
    -webkit-animation-duration: 4000ms;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-timing-function: linear;
    -moz-animation-name: spin;
    -moz-animation-duration: 4000ms;
    -moz-animation-iteration-count: infinite;
    -moz-animation-timing-function: linear;
    -ms-animation-name: spin;
    -ms-animation-duration: 4000ms;
    -ms-animation-iteration-count: infinite;
    -ms-animation-timing-function: linear;

    animation-name: spin;
    animation-duration: 4000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}
@-ms-keyframes spin {
    from { -ms-transform: rotate(0deg); }
    to { -ms-transform: rotate(360deg); }
}
@-moz-keyframes spin {
    from { -moz-transform: rotate(0deg); }
    to { -moz-transform: rotate(360deg); }
}
@-webkit-keyframes spin {
    from { -webkit-transform: rotate(0deg); }
    to { -webkit-transform: rotate(360deg); }
}
@keyframes spin {
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
}

.grid-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 25px !important;
  border-radius: 0;
  min-height: 260px;
  border: 1px solid #eaeaea;
  box-shadow: 0px 0px 2px #0000004C;
  padding: 40px 10px 20px;
  transition:0.4s;
  &:hover{
    background: #F5F8FB;
    border:1px solid #8FB3D0;
    .textButton {
      color:$primary-color;
    }
  }
  img{
    height: 100px;
  }
  .textButton{
    color: #757575;
    font-size: 17px;
    font-weight: 500;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    transition: 0.4s;
  }
}

.col-xs-offset-1{
  margin-left: 0;
}

.logoutBtn {
  color: #E7E8E9!important;
  font-size: 17px!important;
  font-weight: 500!important;
  background: $primary-color!important;
  border: 1px solid #E7E8E9!important;
  box-shadow: 0px 0px 3px #0000004C!important;
  transition: 0.4s!important;
  &:hover, &:focus{
    background: #F5F8FB!important;
    border:1px solid #8FB3D0!important;
    color:$primary-color!important;
  }
}
@media screen and (max-width: 700px) {
  .nav-icon{
    display: none;
  }
  .sideMenu{
    padding: 50px 0;
    display: none;
  }
  .el-drawer.sideMenu{
    width: 80%!important;
    height: 100vh!important;
    overflow-y: auto;
}
  .sideMenu .el-icon-close{
    position: absolute;
    text-align: left;
  }
  .col-xs-offset-1{
    margin-left: 8%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/Sections/Navbar/SideMenu.vue